import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal'

import '../../css/SingleScreens/NotificationPreferences.css';

import { StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, Button, SingleScreenNavBar, Switch, Input } from  '../../components'

class PracticeNotificationPreferencesScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded_category: '',
      updated_preferences: null,
      email_input: '',
      phone_input: '',
      selected_push_member: '',
      display_email_input: false,
      display_phone_input: false,
      display_push_modal: false,
      staff_members: null,
      staff_members_dict: {},
    }
  }

  componentDidMount() {
    let preferences   = this.props.practice && this.props.practice.notificationPreferences ? this.props.practice.notificationPreferences : null;
    let staff         = this.props.practice && this.props.practice.staff ? this.props.practice.staff : [];
    let staff_details = this.retrieveStaffDetails(staff);

    this.setState({ ...this.state, updated_preferences: preferences, staff_members: staff_details.array, staff_members_dict: staff_details.dict });
  }

  renderLine = () => {
    return <div style={{ width: '100%', backgroundColor: '#e7e7e7', height: 1, marginTop: 12, marginBottom: 10 }}></div>
  }

  renderPracticeNotificationPreferencesSection = (preferences) => {
    if (!preferences) {
      return null;
    }

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="notification-preferences-container">

        <div className='flex-container-row' style={{ alignItems: 'center', marginBottom: 10 }}>
          <h5 style={{ flex: 1 }}>Notification Categories</h5>
          <div className='flex-container-row' style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', paddingRight: 5 }}>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}>Email</div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}>Texts</div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}>Push</div>
          </div>
        </div>

        { this.renderCategoryRow('Billing', 'Payment transactions', 'billing', preferences.billing) }
        { this.renderLine() }
        { this.renderCategoryRow('Resolved Consultations', 'Notified when a consultation is resolved', 'resolve_consultation', preferences.resolve_consultation) }
        { this.renderLine() }
        { this.renderCategoryRow('New Consultations', 'Notified when a consultation is created', 'new_consultation', preferences.new_consultation) }
        { this.renderLine() }
        { this.renderCategoryRow('New Messages', 'New message received in a consultation', 'new_message', preferences.new_message) }
        { this.renderLine() }
        { this.renderCategoryRow('New Task', 'Front Desk task created', 'new_task', preferences.new_task) }
        { this.renderLine() }
        { this.renderCategoryRow('Medical Notes', 'Medical Note created', 'medical_notes', preferences.medical_notes) }
        { this.renderLine() }
        { this.renderCategoryRow('Appointments', 'New and Updated Appointments', 'appointments', preferences.appointments) }

        </div>
      </div>
    </div>
  }

  renderCategoryRow = (title, description, key, category) => {
    let email_on = category && category.email && category.email.on ? true : false;
    let text_on  = category && category.text && category.text.on ? true : false;
    let push_on  = category && category.push && category.push.on ? true : false;

    let row_expanded = this.state.expanded_category === key ? true : false;

    return <div>
      <div className='flex-container-row' style={{ alignItems: 'center' }}>
        <div className='flex-container-column' style={{ flex: 1 }}>
          <span style={{ fontSize: row_expanded ? 24 : 16 }}>{ title }</span>
          <span style={{ fontSize: 12, color: row_expanded ? 'white' : 'grey', marginTop: -3 }}>{ description }</span>
        </div>

        { row_expanded ? null : <div className='flex-container-row category-row-switches-container'
             style={{ flex: 1, justifyContent: 'space-between', alignItems: 'center' }}
             onClick={ () => { this.setState({ ...this.state, expanded_category: key }) }}>
          <span style={{ marginLeft: 10, fontSize: 13, fontWeight: 'bold' }}>Edit Recipients</span>
          <div className='flex-container-row'>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={email_on} /></div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={text_on} /></div>
            <div className='flex-container-row' style={{ width: 60, justifyContent: 'center', fontSize: 14 }}><Switch on={push_on} /></div>
          </div>
        </div> }

      </div>
      { this.renderExpandedRow(row_expanded, key, category) }
    </div>
  }

  renderExpandedRow = (display, key, category) => {
    if (!display) {
      return null;
    }

    let email_on = category && category.email && category.email.on ? true : false;
    let text_on  = category && category.text && category.text.on ? true : false;
    let push_on  = category && category.push && category.push.on ? true : false;

    let email_recipients = category && category.email && category.email.recipients ? category.email.recipients : [];
    let text_recipients  = category && category.text && category.text.recipients ? category.text.recipients : [];
    let push_recipients  = category && category.push && category.push.recipients ? category.push.recipients : [];

    return <div>
      <div className='flex-container-row' style={{ marginBottom: 10, alignItems: 'center' }}>
        <div className='flex-container-row' style={{ flex: 1, alignItems: 'center', justifyContent: 'space-between', paddingRight: 30 }}><span style={{ marginRight: 10, fontSize: 14 }}>Email</span><Switch small={true} on={email_on} onClick={ () => { this.updateSwitchValue(!email_on, 'email', key) }} /></div>
        <div className='flex-container-row' style={{ flex: 1, alignItems: 'center', justifyContent: 'space-between', paddingRight: 30 }}><span style={{ marginRight: 10, fontSize: 14 }}>Texts</span><Switch small={true} on={text_on} onClick={ () => { this.updateSwitchValue(!text_on, 'text', key) }} /></div>
        <div className='flex-container-row' style={{ flex: 1, alignItems: 'center', justifyContent: 'space-between', paddingRight: 30 }}><span style={{ marginRight: 10, fontSize: 14 }}>Push</span><Switch small={true} on={push_on} onClick={ () => { this.updateSwitchValue(!push_on, 'push', key) }} /></div>
      </div>

      <div className='flex-container-row' style={{ marginTop: 5, alignItems: 'flex-start' }}>
        <div className='flex-container-column' style={{ flex: 1 }}>{ this.renderEmailsList(email_recipients, key) }</div>
        <div className='flex-container-column' style={{ flex: 1 }}>{ this.renderTextsList(text_recipients, key) }</div>
        <div className='flex-container-column' style={{ flex: 1 }}>{ this.renderPushList(push_recipients, key) }</div>
      </div>

      <div className='flex-container-row' style={{ marginTop: 5, alignItems: 'center' }}>
        <div className='flex-container-column' style={{ flex: 1, paddingRight: 10 }}>{ this.renderAddEmailButton(key) }</div>
        <div className='flex-container-column' style={{ flex: 1, paddingRight: 10 }}>{ this.renderAddPhoneButton(key) }</div>
        <div className='flex-container-column' style={{ flex: 1, paddingRight: 10 }}>{ this.renderAddUserButton(key) }</div>
      </div>

      <div className='flex-container-row' style={{ marginTop: 10, justifyContent: 'flex-end' }}>
        <Button value='Close' onClick={ () => { this.setState({ ...this.state, expanded_category: '' }) }}/>
      </div>
    </div>
  }

  renderAddEmailButton = (key) => {
    let display_input = this.state.expanded_category === key && this.state.display_email_input ? true : false;

    if (display_input) {
      return <div className='flex-container-column' style={{ marginTop: 10 }}>
        <Input  value={this.state.email_input}
                placeholder="Email Address"
                style={{ fontSize: 14 }}
                onChange={ (event) => { this.setState({ ...this.state, email_input: event.target.value }) }}
              />
        <div className='flex-container-row' style={{ justifyContent: 'flex-end', alignItems: 'center', marginTop: 5 }}>
          <Button value='Cancel' className='button-clear-blue' onClick={ () => { this.setState({ ...this.state, display_email_input: false, email_input: '' }) }}/>
          <Button className='button-default'
                         value='+ Add'
                         style={{ marginLeft: 5 }}
                         onClick={ () => {
                           let new_email          = this.state.email_input.toLowerCase();
                           let preferences        = this.state.updated_preferences;
                           let current_recipients = preferences[key]['email'].recipients || [];
                           let already_exists     = current_recipients.indexOf(new_email) === -1 ? false : true;

                           if (already_exists) {
                             this.setState({ ...this.state, display_email_input: false, email_input: '' })
                             return;
                           }

                           current_recipients.push(new_email)
                           preferences[key]['email'].recipients = current_recipients;
                           this.setState({ ...this.state, display_email_input: false, updated_preferences: preferences, email_input: '' });
                           this.pushNotificationPreferencesUpdate();
                         }}/>
        </div>
      </div>

    } else {
      return <Button className='button-clear-blue'
                     value='+ Add Email'
                     onClick={ () => {
                       this.setState({ ...this.state, display_email_input: true })
                     }}/>
    }
  }

  renderAddPhoneButton = (key) => {
    let display_input = this.state.expanded_category === key && this.state.display_phone_input ? true : false;

    if (display_input) {
      return <div className='flex-container-column' style={{ marginTop: 10 }}>
        <Input  value={this.state.phone_input}
                placeholder="Phone Number"
                style={{ fontSize: 14 }}
                onChange={ (event) => { this.setState({ ...this.state, phone_input: event.target.value }) }}
              />
        <div className='flex-container-row' style={{ justifyContent: 'flex-end', alignItems: 'center', marginTop: 5 }}>
          <Button value='Cancel' className='button-clear-blue' onClick={ () => { this.setState({ ...this.state, display_phone_input: false, phone_input: '' }) }}/>
          <Button className='button-default'
                         value='+ Add'
                         style={{ marginLeft: 5 }}
                         onClick={ () => {
                           let new_phone          = this.state.phone_input;
                           let preferences        = this.state.updated_preferences;
                           let current_recipients = preferences[key]['text'].recipients || [];
                           let already_exists     = current_recipients.indexOf(new_phone) === -1 ? false : true;

                           if (already_exists) {
                             this.setState({ ...this.state, display_phone_input: false, phone_input: '' })
                             return;
                           }

                           current_recipients.push(new_phone)
                           preferences[key]['text'].recipients = current_recipients;
                           this.setState({ ...this.state, display_phone_input: false, updated_preferences: preferences, phone_input: '' })
                           this.pushNotificationPreferencesUpdate();
                         }}/>
        </div>
      </div>

    } else {
      return <Button className='button-clear-blue'
                     value='+ Add Phone'
                     onClick={ () => {
                       this.setState({ ...this.state, display_phone_input: true })
                     }}/>
    }
  }

  renderAddUserButton = (key) => {
    return <Button className='button-clear-blue'
                   value='+ Add User'
                   onClick={ () => {
                     this.setState({ ...this.state, display_push_modal: true })
                   }}/>
  }

  renderEmailsList = (emails, key) => {
    let email_addresses = emails || [];
    let email_rows = email_addresses.map((email_address) => {
      return <div className='flex-container-row' style={{ justifyContent: 'space-between' }} key={email_address}>
        <span style={{ color: 'grey', fontSize: 13 }}>{ email_address }</span>
        <span className="fas fa-times-circle remove-recipient-button"
              style={{ marginRight: 30 }}
              onClick={ () => {
                let preferences        = this.state.updated_preferences;
                let current_recipients = preferences[key]['email'].recipients || [];
                let index_of_email     = current_recipients.indexOf(email_address);
                if (index_of_email !== -1 && index_of_email < current_recipients.length) {
                  current_recipients.splice(index_of_email, 1);
                  preferences[key]['email'].recipients = current_recipients;
                  this.setState({ ...this.state, updated_preferences: preferences })
                  this.pushNotificationPreferencesUpdate();
                }
              }}/>
      </div>
    }).filter((email) => { return email });

    return <div className='flex-container-column'>
      { email_rows }
    </div>
  }

  renderTextsList = (phone_numbers, key) => {
    let numbers = phone_numbers || [];
    let number_rows = numbers.map((number) => {
      return <div className='flex-container-row' style={{ justifyContent: 'space-between' }} key={number}>
        <span style={{ color: 'grey', fontSize: 13 }}>{ StringUtils.displayPhoneNumber(number) }</span>
        <span className="fas fa-times-circle remove-recipient-button"
              style={{ marginRight: 30 }}
              onClick={ () => {
                let preferences        = this.state.updated_preferences;
                let current_recipients = preferences[key]['text'].recipients || [];
                let index_of_phone     = current_recipients.indexOf(number);
                if (index_of_phone !== -1 && index_of_phone < current_recipients.length) {
                  current_recipients.splice(index_of_phone, 1);
                  preferences[key]['text'].recipients = current_recipients;
                  this.setState({ ...this.state, updated_preferences: preferences })
                  this.pushNotificationPreferencesUpdate();
                }
              }}/>
      </div>
    }).filter((row) => { return row });

    return <div className='flex-container-column'>
      { number_rows }
    </div>
  }

  renderPushList = (user_ids, key) => {
    let _ids = user_ids || [];
    let user_rows = _ids.map((user_id) => {
      let user_info = this.state.staff_members_dict && this.state.staff_members_dict[user_id] ? this.state.staff_members_dict[user_id] : {};
      return <div className='flex-container-row' style={{ justifyContent: 'space-between' }} key={user_id}>
        <span style={{ color: 'grey', fontSize: 13 }}>{ StringUtils.displayName(user_info) }</span>
        <span className="fas fa-times-circle remove-recipient-button"
              style={{ marginRight: 30 }}
              onClick={ () => {
                let preferences        = this.state.updated_preferences;
                let current_recipients = preferences[key]['push'].recipients || [];
                let index_of_id        = current_recipients.indexOf(user_id);
                if (index_of_id !== -1 && index_of_id < current_recipients.length) {
                  current_recipients.splice(index_of_id, 1);
                  preferences[key]['push'].recipients = current_recipients;
                  this.setState({ ...this.state, updated_preferences: preferences })
                  this.pushNotificationPreferencesUpdate();
                }
              }} />
      </div>
    }).filter((row) => { return row });

    return <div className='flex-container-column' style={{ }}>
      { user_rows }
    </div>
  }

  renderUserSelectionModal = () => {
    let staff_members   = this.state.staff_members || [];
    let selected_member = this.state.selected_push_member || '';

    let staff_rows = staff_members.map((member) => {
      let currently_selected = member._id === selected_member ? true : false;
      let icon_class_name    = currently_selected ? "fas fa-check-circle" : "far fa-circle";
      return <div className='flex-container-row user-selection-list-item' key={member._id}
                  style={{ justifyContent: 'space-between', marginBottom: 3 }}
                  onClick={ () => {
                    this.setState({ ...this.state, selected_push_member: member._id })
                  }}>
        <span style={{ fontSize: 14 }}>{ StringUtils.displayName(member) }</span>
        <span className={icon_class_name} style={{ color: currently_selected ? '#1dc2ff' : '#e7e7e7' }} />
      </div>
    }).filter((row) => { return row });

    return <Modal show={this.state.display_push_modal}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <h4>Add User to Push Notifications</h4>
        <div>
          { staff_rows }
        </div>
        <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 10 }}>
          <Button value='Cancel' className='button-clear-blue' style={{ marginRight: 5 }} onClick={ () => { this.setState({ ...this.state, display_push_modal: false, selected_push_member: '' }) } }/>
          <Button value='Add'
                  onClick={ () => {
                    let key                = this.state.expanded_category;
                    let new_push           = this.state.selected_push_member;
                    let preferences        = this.state.updated_preferences;
                    let current_recipients = preferences[key]['push'].recipients || [];
                    let already_exists     = current_recipients.indexOf(new_push) === -1 ? false : true;

                    if (already_exists) {
                      this.setState({ ...this.state, display_push_modal: false, selected_push_member: '' })
                      return;
                    }

                    current_recipients.push(new_push)
                    preferences[key]['push'].recipients = current_recipients;
                    this.setState({ ...this.state, display_push_modal: false, updated_preferences: preferences, selected_push_member: '' })
                    this.pushNotificationPreferencesUpdate();
                  }}/>
        </div>
      </div>
    </Modal>
  }

  render() {
    let preferences = this.state.updated_preferences;

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Notification Preferences" />
        { this.renderPracticeNotificationPreferencesSection(preferences) }
        { this.renderUserSelectionModal() }
      </div>
    );
  }

  updateSwitchValue = (new_value, notif_method, category_key) => {
    let preferences = this.state.updated_preferences;
    preferences[category_key][notif_method].on = new_value;
    this.setState({ ...this.state, updated_preferences: preferences });
    this.pushNotificationPreferencesUpdate();
  }

  retrieveStaffDetails = (staff) => {
    let staff_dict = {}
    let staff_details = staff.map((member) => {
      let user_info = member && member.user_details && member.user_details[0] ? member.user_details[0] : null;
      if (user_info) {
        staff_dict[user_info._id] = user_info;
        return user_info
      }
    }).filter((info) => { return info });

    return {
      array: staff_details,
      dict: staff_dict,
    };
  }

  pushNotificationPreferencesUpdate = () => {
    let updated_preferences = this.state.updated_preferences;
    let token = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    if (token && updated_preferences) {
      this.props.practiceActions.updatePracticeNotificationPreferences(token, updated_preferences);
    }
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeNotificationPreferencesScreen)
